module.exports = __webpack_public_path__ + "static/img/emoji_6.7a782142.png";